import React from 'react';

import { PieChartOutlined } from '@ant-design/icons';
import { PermissionEnum } from '@modules/permissions/entity';
import { IRouter } from '@routers/interface';

export const routerReport: IRouter = {
  path: '/report',
  loader: React.lazy(() => import('./index')),
  exact: true,
  name: 'report.name', //translate here for breadcrumb and sidebar
  masterLayout: true,
  permissionCode: PermissionEnum.ReportsView,
  menu: {
    icon: <PieChartOutlined />,
  },
};
